import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
//Material imports
import Typography from "@material-ui/core/Typography";
import Fade from "@material-ui/core/Fade";

var SlideTitle = function SlideTitle(_ref) {
  var slide = _ref.slide,
      shouldAnimate = _ref.shouldAnimate,
      gutterBottom = _ref.gutterBottom,
      style = _ref.style;
  var title = slide.title,
      backgroundColor = slide.backgroundColor,
      titleColor = slide.titleColor,
      titleFontSize = slide.titleFontSize;
  var titleSize = titleFontSize || "21px";
  return /*#__PURE__*/React.createElement(Fade, {
    direction: "down",
    in: true,
    timeout: 500,
    style: {
      transitionDelay: "0.3s"
    },
    appear: shouldAnimate
  }, /*#__PURE__*/React.createElement(Typography, {
    align: "center",
    variant: "h6",
    style: _objectSpread({}, {
      color: titleColor,
      backgroundColor: backgroundColor,
      fontSize: titleSize
    }, {}, style),
    component: "span",
    id: "hiwTitle",
    gutterBottom: gutterBottom
  }, title));
};

export default SlideTitle;